import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { NavbarConfig, NavbarLink } from '../types/NavbarTypes';
import { loadYaml } from '../utilis/loadYAML';
import { motion, AnimatePresence } from 'framer-motion';


import { MdAccountBalance,MdApartment  } from "react-icons/md";



const navbarIconMap: Record<string, any> = {
  Govt: MdAccountBalance,
  B2B: MdApartment
};

const getIconByName = (name: string): React.ReactNode | null => {
  const IconComponent = navbarIconMap[name];
  if (!IconComponent) {
    console.warn(`Icon not found for menu item: ${name}`);
    return null;
  }
  return React.createElement(IconComponent, { className: 'nav-icon' });
};

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdown, setDropdown] = useState<string | null>(null);
  const [config, setConfig] = useState<NavbarConfig | null>(null);
  const [mode, setMode] = useState<'Govt' | 'B2B'>('Govt');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    loadYaml('/config/navbar.yaml').then((data) => {
      setConfig(data as NavbarConfig);
    });
  }, []);

  if (!config) return null;

  const getDropdownItem = (name: string): NavbarLink | undefined =>
    config.menu.find((m) => m.name === name && m.promo);

  return (
    <>
      <div className="top-strip">
        <span
          className={`mode-text ${mode === 'Govt' ? 'active' : ''}`}
          onClick={() => setMode('Govt')}
        >
          {getIconByName('Govt')} Govt
        </span>
        <span
          className={`mode-text ${mode === 'B2B' ? 'active' : ''}`}
          onClick={() => setMode('Govt')} 
        >
            {getIconByName('B2B')} B2B
        </span>
        
      </div>

      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-logo">
          <a href={config.brand.link}>
            <img src={config.brand.logo} alt={config.brand.name} className="navbar-logo-img" />
          </a>
        </div>

        <ul className="navbar-menu">
          {config.menu.map((item, idx) => (
            <li
              key={idx}
              className={`nav-item ${item.type === 'button' ? 'nav-button' : ''}`}
              onMouseEnter={() => item.promo && setDropdown(item.name)}
              onMouseLeave={() => item.promo && setDropdown(null)}
            >
              {item.type === 'button' ? (
                <a href={item.href} className="hire-btn navbar-link">
                  {getIconByName(item.name)}
                  {item.name}
                </a>
              ) : (
                <a href={item.href || '#'} className="navbar-link">
                  {getIconByName(item.name)}
                  {item.name}
                </a>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <AnimatePresence>
        {dropdown && (() => {
          const item = getDropdownItem(dropdown);
          if (!item || !item.promo) return null;

          return (
            <motion.div
              className="bifurcated-dropdown"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.25, ease: 'easeInOut' }}
              onMouseLeave={() => setDropdown(null)}
            >
              <div className="left">
                <h2>{item.promo.title}</h2>
              </div>
              <div className="right">
                <p>{item.promo.description}</p>
              </div>
            </motion.div>
          );
        })()}
      </AnimatePresence>
    </>
  );
}

export default Navbar;
